module.exports = __webpack_public_path__ + "img/veloster-indicator.9940259b.png";